import React, { useState, useEffect } from "react";
// import BoardTable from "../components/BoardTable";
import MainTable from "../components/MainTable";
import config from "../config/config";
import BoardWriteBox from "../components/BoardWriteBox";
const API_URL = config.API_URL;

function BoardNetworking() {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [editing, setEditing] = useState(false);
  // const [boardDetailModalOpen, setBoardDetailModalOpen] = useState(false);
  const typeKey = "Network";
  const typeKeyKor = "입주기업 네트워킹";

  const boardTypeList = [
    { key: 'all', label: '전체', titleLabel: '전체게시판' , badgeColor: "var(--main-blue_10)", textColor: "var(--main-blue_70)"},
    { key: 'info', label: '정보공유', titleLabel: '정보공유게시판', badgeColor: "var(--main-yellow_10)", textColor: "var(--main-yellow_80)"},
    { key: 'buy', label: '사고팔기', titleLabel: '사고팔기' , badgeColor: "var(--main-pink_10)", textColor: "var(--main-pink_70)"},
    { key: 'free', label: '자유', titleLabel: '자유게시판' , badgeColor: "var(--main-green_20)", textColor: "var(--main-green_80)"},
  ];

  //신규 작성 파트 (파트별 변경 필요)`
  useEffect(() => {
    const eventHandler = () => {
      console.log(`🟣 [Board] newBoardEntry_${typeKey} 감지됨!`);
      handleNewEntry();
    };

    window.addEventListener(`newBoardEntry_${typeKey}`, eventHandler);
    return () => {
      console.log("⚪ [Board] 이벤트 리스너 제거됨");
      window.removeEventListener(`newBoardEntry_${typeKey}`, eventHandler);
    };
  }, []);
  const handleNewEntry = () => {
    console.log("handle new Entry 실행됨");
    setSelectedRow(null);
    setEditing(true);
    setIsModalOpen(true);
  };

  const handleClose = (reload) =>{
    console.log('handle Close 실행됨');
    if(reload){
      fetchData();
    }
    setIsModalOpen(false);
  }

  // API 호출 함수
  const fetchData = async () => {
    try {
      const response = await fetch(`${API_URL}/api/board/get${typeKey}List`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
        credentials: "include"
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const result = await response.json();
      // console.log(result.value);

      if (result.result && Array.isArray(result.value)) {
        // 데이터를 변환하여 company -> startup_name 매핑
        const formattedData = result.value.map((row, index) => ({
          _id: row._id || index + 1, // ID 설정
          id: index + 1,
          title : row.title || '-',
          boardNetworkCategory : row.category || "all",
          name: row.name || "-", 
          account : row.account || "-",
          date: row.up_date ? row.up_date.split("T")[0] : "-", // 날짜만 추출,
        }));
        setData(formattedData);
      } else {
        console.error("데이터 가져오기 실패:", result.message);
      }
    } catch (error) {
      console.error("Error fetching board data:", error);
      // setError(error.message); // 에러 메시지 저장
    } finally {
      setLoading(false); // 데이터 로딩 완료
    }
  };
  useEffect(() => {
    fetchData();
  }, []);

  const handleBoardRowClick = (_id) =>{
    setEditing(false);
    setSelectedRow(_id);
    setIsModalOpen(true);
  }

  const headTitles = [
    { key: "_id", label: "", searchable: false},
    { key: 'id', label: '순번', searchable: false },
    { key: 'boardNetworkCategory', label: '분류'},
    { key: 'title', label: '제목' },
    { key: 'name', label: '작성자' },
    { key: 'date', label: '일시' },
  ];

  // const data = [
  //   { id: 1, date: "2024-01-01", title: "게시판 제목 1", author: "작성자 A" },
  //   { id: 2, date: "2024-01-15", title: "게시판 제목 2", author: "작성자 B" },
  // ];

  return (
    <div style={{display: "flex", flex: 1}}> 
      {loading ? (
        <p>Loading...</p>
      ):(
        <>
          {/* mainTable의 일부에서 category 가 boardType으로 되어있음 */}
          <MainTable title={typeKeyKor} tableHeadTitles={headTitles} tableData={data} boardRowClick={handleBoardRowClick} boardTypeList={boardTypeList}
          pageType={'board'} mainSearchKey="title"/>
          {isModalOpen && (
            <BoardWriteBox boardTypeId={typeKey} boardTypeName={typeKeyKor} onClose={handleClose} boardId={selectedRow} edit={editing} boardCategoryList={boardTypeList} />
          )}
        </>
      )}
    </div>
  );

  // const boardTypeList = [
  //   { key: 'all', label: '전체', titleLabel: '전체게시판' , badgeColor: "var(--main-blue_10)", textColor: "var(--main-blue_70)"},
  //   { key: 'info', label: '정보공유', titleLabel: '정보공유게시판', badgeColor: "var(--main-yellow_10)", textColor: "var(--main-yellow_80)"},
  // ];
  
  // const data = [
  //   { id: 1, date: "2024-01-01", title: "게시판 제목 1", author: "작성자 A", boardType: "info" },
  // ];

  // return <MainTable tableHeadTitles={headTitles} tableData={data} boardTypeList={boardTypeList}
  //   pageType={'board'}/>;
}

export default BoardNetworking;